import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useUserRoles } from '@anytag/auth';
import { useAllPicUserOptions, useAllCampaignCategoryOptions } from '@anytag/shared-hooks';
import { Filter, SelectorField, FILTER_SECTIONS, AsyncSearchHubspotDealField } from '@anytag/shared-molecules';
import { EngagementCampaignsFilterFormValues, EngagementCampaignsFilterFormKeys } from './schemaTypes';
import { defaultEngagementCampaignsFilterValues } from './utils';

interface AdvancedFilterProps {
  onSubmit?: () => void;
}

export const AdvancedFilter = ({ onSubmit }: AdvancedFilterProps) => {
  const { t } = useTranslation();
  const { isAdminStaff } = useUserRoles();
  const { allPicsUserOptions } = useAllPicUserOptions();
  const { allCampaignCategoryOptions } = useAllCampaignCategoryOptions();
  const { watch, reset } = useFormContext<EngagementCampaignsFilterFormValues>();

  const values = watch();
  const advancedFilterValues = [
    values.salesPicIds,
    values.hubspotDealIds,
    values.influencerPicIds,
    values.campaignCategoryIds
  ];
  const numOfValidFilter = advancedFilterValues.filter((value) => value.length).length;

  const handleClear = () => {
    reset({
      ...defaultEngagementCampaignsFilterValues,
      // Basic filter
      status: values.status,
      keyword: values.keyword,
      countryIds: values.countryIds
    });
  };

  return (
    <Filter.MoreFilterPopover
      onSubmit={onSubmit}
      onClear={handleClear}
      count={numOfValidFilter}
      defaultOpened={[FILTER_SECTIONS.CampaignInformation]}
      items={[
        {
          value: FILTER_SECTIONS.CampaignInformation,
          node: (
            <>
              <SelectorField<EngagementCampaignsFilterFormKeys>
                title={t('Selector.Campaign Category')}
                name="campaignCategoryIds"
                options={allCampaignCategoryOptions}
                multiple
              />
              {isAdminStaff ? (
                <>
                  <SelectorField<EngagementCampaignsFilterFormKeys>
                    name="salesPicIds"
                    hasSelectAll={false}
                    help={t('Tooltip.Sales PIC')}
                    title={t('Selector.Sales PIC')}
                    options={allPicsUserOptions}
                    multiple
                  />

                  <SelectorField<EngagementCampaignsFilterFormKeys>
                    hasSelectAll={false}
                    name="influencerPicIds"
                    options={allPicsUserOptions}
                    help={t('Tooltip.Influencer Management PIC')}
                    title={t('Selector.Influencer Management PIC')}
                    multiple
                  />

                  <AsyncSearchHubspotDealField<EngagementCampaignsFilterFormKeys> name="hubspotDealIds" multiple />
                </>
              ) : null}
            </>
          )
        }
      ]}
    />
  );
};
